export const environment = {
    name: "QA",
    api: {
        // baseURL: 'http://timex-api.porter.local',
        baseURL: "https://timex-api.flyporter.com",
        // baseURL: "https://localhost:44377",
        // baseURL: "https://qa-timex-api.flyporter.com",
        getFlightDetailsURL: "/api/v1/flightDetails",
        //getStationNamesURL: '/airports.api/v1/airports',
        getStationNamesURL: "/api/v1/stationDetails",
        sendClientConnectionIDURL: "/api/v1/setClientStation?connectionId=",
        validateTokenURL: "/api/v1/validateToken",
        removeConnection: "/api/v1/connection",
        logOutURL: "/api/v1/logOut",
        signalRHubURL: "/timexHub",
    },
    settings: {
        ignoreFlightFilter: false,
        reloadOnTimeout: 60,
    },
    authorization: {
        token: "",
    },
    ignoreAuthentication: false,
    trunTimeOffset: 30,
    maps: {
        statements: {
            boarding: "Cabin Ready / Positive Boarding",
            boardingcomplete: "Boarding Complete",
            wbsubmit: "Submit W&B",
            doorclose: "Door close at",
        },
        fleetTypes: {
            Dash8: "DHC8-402",
            E195: "295",
        },
        times: {
            Dash8: {
                boarding: 25,
                boardingcomplete: 10,
                wbsubmit: 9,
                doorclose: 3,
            },
            E195: {
                boarding: 30,
                boardingcomplete: 10,
                wbsubmit: 9,
                doorclose: 3,
            },
        },
        checks: {
            boarding: "IsPaxBoarded",
            boardingcomplete: "IsAllPaxBoarded",
            wbsubmit: "IsWBSubmit",
            doorclose: "IsDoorClosed",
        },
    },
    targetTurnTime: {
        Dash8: 35,
        E195: 50,
    },
    maxTimeWindow: 6,
};
